import React, { useState } from 'react';
import FlatList from 'flatlist-react/lib';
import './Areas.scss';
import Spinner from '../../Spinner';
import { useUserContext } from '../../../contexts/UserContext';
import TeamArea from './TeamArea';

const MemoizedTeamArea = React.memo(TeamArea);

export default function TeamAreas(props) {
    const {
        teamAreas,
        setTeamAreas,
        panel ,
        setPanel,
        map,
        user,
        modal,
        setModal
    } = props;

    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);

    const renderAreaRow = (a) => {
        return (
            <MemoizedTeamArea
                a={a}
                teamAreas={teamAreas}
                setTeamAreas={setTeamAreas}
                panel={panel} 
                setPanel={setPanel}
                map={map}
                user={user}
                modal={modal}
                setModal={setModal}
            />
        );
    }

    teamAreas && console.log('teamAreas', teamAreas.slice(0, 5));

    return (
        <div className='all-area-types'>
            <div className='all-area-types-search'>
                <input 
                    type='text'
                    placeholder='Search by address/name'
                    className='all-area-types-search-input'
                    onChange={(e) => setSearch(e.target.value)}
                    />
            </div>
            <div 
                className='all-area-types-new-area-btn'
                onClick={() => {
                    setPanel({
                        name: 'Monitoring Areas - Create',
                        content: null
                    })
                }}    
                >
                Create New Area +
            </div>
            {loading ?
            <Spinner />
            :
            <div className='all-area-types-list'>
                <FlatList
                    list={teamAreas.filter((area) => area.name.toLowerCase().includes(search.toLowerCase()))}
                    renderItem={renderAreaRow}
                    renderOnScroll
                    renderWhenEmpty={() => (
                      <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        padding: '2rem',
                        textAlign: 'center',
                        color: '#666'
                      }}>
                        <div style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                          No team areas found
                        </div>
                        <div style={{ fontSize: '0.9rem' }}>
                          Try adjusting your search criteria or check with your team
                        </div>
                      </div>
                    )}
                />
            </div>}
        </div>
    )
}